module.exports = __webpack_public_path__ + "static/media/MD.e30f04f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MD.svg
// module id = 2204
// module chunks = 7